import { Workbook } from 'exceljs';

/**
 * Function to generate an Excel file from a workbook and download it.
 * @param workbook The Excel workbook to be downloaded
 * @param filename The name of the file to be downloaded (without extension)
 */
export const downloadExcel = async (workbook: Workbook, filename: string): Promise<void> => {
  // Generate and download the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
};
